export default "__VITE_ASSET__7782fb6c__"